"use client";

import { useRumPageView } from "@/components/rum-provider";

export function RumPageEvent({
	name,
	properties,
}: {
	name: string;
	properties?: Record<string, unknown>;
}) {
	useRumPageView(name, properties);
	return null;
}
